import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; 

import authReducer from "./authSlice";
import productReducer from './productSlice';
import manageProductReducer from './manageProductSlice';
import dashboardReducer from './dashboardSlice';
import saleReducer from './saleSlice';
import customerReducer from './customerSlice';

const rootReducer = combineReducers({
  auth: authReducer, 
  products: productReducer, 
  manageProduct: manageProductReducer, 
  sales: saleReducer, 
  dashboard: dashboardReducer, 
  customer: customerReducer, 
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
